export const FILE_ACCEPT = ".pdf,.csv,.txt,.md,.markdown,.png,.jpg,.jpeg,.gif,.webp";
export const MAX_FILE_BYTES = 20 * 1024 * 1024;
export const MAX_FILES_PER_UPLOAD = 8;

const EXTENSIONS = new Set(["pdf", "csv", "txt", "md", "markdown", "png", "jpg", "jpeg", "gif", "webp"]);

const STATUS_LABELS = {
  uploading: "Uploading",
  processing: "Processing",
  ready: "Ready",
  failed: "Failed",
};

export function statusLabel(status) {
  return STATUS_LABELS[status] || "Waiting";
}

export function generatedLibrary(index, conversations) {
  const live = conversations && typeof conversations === "object" ? conversations : {};
  const rows = new Map();

  function add(id, file, conversationId) {
    if (!id || !file || typeof file !== "object" || file.Source !== "generated") return;
    const previous = rows.get(id);
    rows.set(id, {
      id,
      name: file.Name || previous?.name || "File",
      path: file.Path || previous?.path || "",
      status: file.Status || previous?.status || "",
      error: file.Error || "",
      createdAt: file.CreatedAt || previous?.createdAt || "",
      kind: file.Kind || previous?.kind || "",
      text: typeof file.Text === "string" ? file.Text : previous?.text,
      snapshots: file.Snapshots && typeof file.Snapshots === "object" ? file.Snapshots : previous?.snapshots || {},
      conversationId: conversationId || previous?.conversationId || "",
    });
  }

  for (const [conversationId, conversation] of Object.entries(live)) {
    if (!conversation || typeof conversation !== "object" || !conversation.Files || typeof conversation.Files !== "object") continue;
    for (const [id, file] of Object.entries(conversation.Files)) add(id, file, conversationId);
  }
  if (index && typeof index === "object") {
    for (const [id, file] of Object.entries(index)) add(id, file, file?.ConversationId || "");
  }

  return [...rows.values()]
    .map((row) => {
      const conversation = live[row.conversationId];
      const conversationExists = Boolean(conversation && typeof conversation === "object");
      return {
        ...row,
        markdown: isMarkdownFile({ name: row.name, kind: row.kind }),
        visualisation: row.kind === "visualisation",
        conversationExists,
        conversationTitle: conversationExists ? (conversation.Title || "New conversation") : "",
      };
    })
    .sort((left, right) => String(right.createdAt).localeCompare(String(left.createdAt)) || left.id.localeCompare(right.id));
}

export function isMarkdownFile(file) {
  if (file?.kind === "markdown" || file?.kind === "visualisation") return true;
  const parts = String(file?.name || "").toLowerCase().split(".");
  if (parts.length < 2) return false;
  const extension = parts.pop();
  return extension === "md" || extension === "markdown";
}

export function validateClientFile(file) {
  if (!file || typeof file.name !== "string" || !file.name.trim()) return "A file name is required.";
  const extension = file.name.split(".").pop().toLowerCase();
  if (!EXTENSIONS.has(extension)) return "Use a PDF, CSV, TXT, Markdown, or image file.";
  if (!Number.isFinite(file.size) || file.size < 1 || file.size > MAX_FILE_BYTES) {
    return "Each file must be between 1 byte and 20 MB.";
  }
  return "";
}
